import { render, staticRenderFns } from "./DeleteSearch.vue?vue&type=template&id=a8888548&scoped=true"
import script from "./DeleteSearch.vue?vue&type=script&lang=js"
export * from "./DeleteSearch.vue?vue&type=script&lang=js"
import style0 from "./DeleteSearch.vue?vue&type=style&index=0&id=a8888548&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8888548",
  null
  
)

export default component.exports